import React from "react";
import { useTranslation } from "react-i18next";
import Popover from "@mui/material/Popover";
import PopupState, { bindTrigger, bindPopover } from "material-ui-popup-state";
import { useMediaQuery } from "@mui/material";
import { Link } from "react-router-dom";
import { INavMenuButtonsProps } from "shared/ui/layout/types/types";
import { NavMenuPopover } from "./NavMenuPopover";
import { useStyles } from "../hooks";

export const NavMenuButtons = (props: INavMenuButtonsProps) => {
  const classes = useStyles();
  const { Roles } = props;
  const xl = useMediaQuery("(min-width:1170px)");
  const lg = useMediaQuery("(min-width:960px)");
  const { t } = useTranslation("shared");
  const buttons = () => {
    if (!lg || !xl) {
      return (
        <>
          {lg && (
            <NavMenuPopover
              headerNavTranslation={"myWork"}
              idPopover={"nav_menu_popover_my_work"}
              navLinksTranslation={["editableDocuments", "myTasks"]}
            />
          )}
          <PopupState variant="popover">
            {(popupState) => (
              <div>
                <button
                  className={classes.linkButton}
                  style={{ flexGrow: 1, borderRadius: "0px 5px 5px 0px" }}
                  {...bindTrigger(popupState)}
                >
                  {t("navmenu.more")}
                </button>
                <Popover
                  {...bindPopover(popupState)}
                  classes={{
                    paper: classes.paperNavMenu,
                  }}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "center",
                  }}
                >
                  {!lg && (
                    <NavMenuPopover
                      headerNavTranslation={"myWork"}
                      idPopover={"nav_menu_popover_my_work"}
                      navLinksTranslation={["editableDocuments", "myTasks"]}
                      isDropButton={true}
                    />
                  )}
                  {(Roles.Administrator || Roles.CompanyAdministrator) && (
                    <NavMenuPopover
                      headerNavTranslation={"admin"}
                      idPopover={"nav_menu_popover_administration"}
                      navLinksTranslation={
                        Roles.Administrator
                          ? [
                              "company",
                              "users",
                              "usersGroup",
                              "accessRestrictionStamp",
                              "settings",
                              "downloadLogs",
                            ]
                          : ["users", "settings"]
                      }
                      isDropButton={true}
                    />
                  )}
                  {(Roles.Administrator ||
                    Roles.CompanyAdministrator ||
                    Roles.Technologist) && (
                    <Link to={`/audit`}>
                      <button
                        className={classes.dropButton}
                        style={{ borderRadius: "0px 5px 5px 0px" }}
                      >
                        {t("navmenu.audit")}
                      </button>
                    </Link>
                  )}
                </Popover>
              </div>
            )}
          </PopupState>
        </>
      );
    }
    return (
      <>
        <NavMenuPopover
          headerNavTranslation={"myWork"}
          idPopover={"nav_menu_popover_my_work"}
          navLinksTranslation={["editableDocuments", "myTasks"]}
        />
        {(Roles.Administrator || Roles.CompanyAdministrator) && (
          <NavMenuPopover
            headerNavTranslation={"admin"}
            idPopover={"nav_menu_popover_administration"}
            navLinksTranslation={
              Roles.Administrator
                ? [
                    "company",
                    "users",
                    "usersGroup",
                    "accessRestrictionStamp",
                    "settings",
                    "downloadLogs",
                  ]
                : ["users", "settings"]
            }
          />
        )}
        {(Roles.Administrator ||
          Roles.CompanyAdministrator ||
          Roles.Technologist) && (
          <Link to={`/audit`}>
            <button
              className={classes.linkButton}
              style={{ borderRadius: "0px 5px 5px 0px" }}
            >
              {t("navmenu.audit")}
            </button>
          </Link>
        )}
      </>
    );
  };

  return (
    <>
      <Link to={`/documents`}>
        <button
          className={classes.linkButton}
          style={{ borderRadius: "5px 0px 0px 5px" }}
        >
          {t("navmenu.documents")}
        </button>
      </Link>
      <Link to={`/tasks`}>
        <button className={classes.linkButton}>{t("navmenu.tasks")}</button>
      </Link>
      {buttons()}
    </>
  );
};
